// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1z9fB","title":"AfterFrontImage_title__Qe7NE"};